import { render, staticRenderFns } from "./SubmitRequestModal.vue?vue&type=template&id=4f0c6840&"
import script from "./SubmitRequestModal.vue?vue&type=script&lang=ts&"
export * from "./SubmitRequestModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f0c6840')) {
      api.createRecord('4f0c6840', component.options)
    } else {
      api.reload('4f0c6840', component.options)
    }
    module.hot.accept("./SubmitRequestModal.vue?vue&type=template&id=4f0c6840&", function () {
      api.rerender('4f0c6840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/request-form/SubmitRequestModal.vue"
export default component.exports